// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button[data-v-68a4da3c]:focus{outline:none}.btn-red-border[data-v-68a4da3c]{max-height:60px}.btn-red-border[data-v-68a4da3c]:hover,.btn-red-border:hover span[data-v-68a4da3c]{color:#fff}", ""]);
// Exports
module.exports = exports;
